import "core-js/stable";
import "regenerator-runtime/runtime";
import React, { Component, useLayoutEffect } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

//react-queries
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./services/queryClient";

//HOC
import requireAuth from "./hoc/require_auth";
import noRequireAuth from "./hoc/no_require_auth";
import withSignedInNotice from "./hoc/with_signed_in_notice";

// Chart.js
import { Chart as ChartJS, registerables } from "chart.js";

// Styles
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import "./styles/scss/style.scss";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { sv } from "date-fns/locale";
// Temp fix for reactstrap
import "./styles/scss/core/_dropdown-menu-right.scss";

// Containers
import Main from "./containers/Main";

// Views Auth
import Signin from "./views/Auth/Signin";

import SelfRegistration from "./views/Student/StudentSelfRegistration";
import RequestResetPassword from "./views/ResetPassword/RequestResetPassword";
import UpdatePassword from "./views/ResetPassword/UpdatePassword";
import PasswordResetAppRedirect from "./views/AppRedirect/PasswordResetAppRedirect";

import { ToastContainer } from "react-toastify";
// Views

import CacheBuster from "react-cache-buster";
import pkg from "../package.json";
import Pacmanloader from "../src/components/Pacmanloader/Pacmanloader";
import NewVersionNotice from "./components/NewVersionNotice/NewVersionNotice";
import SwitchedUserNotice from "./components/SwitchedUserNotice/SwitchedUserNotice";

// Create HOC-wrapped components at module level (avoid re-creation on each render)
const ProtectedMain = requireAuth(Main);
const PublicSelfRegistration = withSignedInNotice(SelfRegistration);
const PublicSignin = noRequireAuth(Signin);
const PublicRequestResetPassword = noRequireAuth(RequestResetPassword);
const PublicUpdatePassword = withSignedInNotice(UpdatePassword);
const PublicPasswordResetAppRedirect = noRequireAuth(PasswordResetAppRedirect);

library.add(fas);
registerLocale("sv", sv);
ChartJS.register(...registerables);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    // Skip on POP (back/forward) so the browser can restore the previous
    // scroll position. Bootstrap's reboot sets html { scroll-behavior: smooth },
    // which makes scrollTo animate — force instant to avoid the visible scroll.
    if (navigationType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, navigationType]);
  return null;
};

const App = () => {
  return (
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Pacmanloader />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={process.env.PUBLIC_URL || "/lwc"}
    >
      <AppOriginal />
    </CacheBuster>
  );
};

class AppOriginal extends Component {
  render() {
    return (
      <div>
        <QueryClientProvider client={queryClient}>
          <ToastContainer
            autoClose={3000}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
            position="bottom-right"
            theme="colored"
          />
          <NewVersionNotice currentVersion={pkg.version} />
          <SwitchedUserNotice />
          <Router>
            <ScrollToTop />
            <Routes>
              <Route
                path="/selfregistration"
                element={<PublicSelfRegistration />}
              />
              <Route path="/login" element={<PublicSignin />} />
              <Route
                path="/password/reset"
                element={<PublicRequestResetPassword />}
              />
              <Route
                path="/activation/resend"
                element={<PublicRequestResetPassword activation />}
              />
              <Route
                path="/password/update"
                element={<PublicUpdatePassword />}
              />
              <Route
                path="/password/redirectToApp"
                element={<PublicPasswordResetAppRedirect />}
              />
              <Route path="/*" element={<ProtectedMain />} />
            </Routes>
          </Router>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </div>
    );
  }
}

export default App;
